import React from 'react';
function About() {
  return (
    <>
  <div className='rightSideCon about'>
  <h1 className="subtopic">About Me</h1>
<h4>Hey there,</h4>
<h1>I'm  Atharva Nimbalkar</h1>
<h3>Passionate about <u>Web and AIML </u></h3>
<br></br>
<p>
A Final Year Undergraduate Student at SPPU Pune pursuing Computer Engineering.
<br></br>
•👀I'm an aspiring Software Developer with a passion for learning and exploring new technologies. As a tech enthusiast, I am particularly interested in web development and Artificial Intelligence and Machine Learning (AIML). I enjoy diving into the world of programming and constantly seek opportunities to expand my knowledge and skills.<br/>
•I have an insatiable thirst for knowledge and eagerly embrace challenges that come my way. I am always looking for new ways to enhance my coding abilities and stay up-to-date with the latest trends and advancements in the field.<br/>
•Love to Explore & Deep Drive In Tech.
<div>
  <button className='btn'><a target='_blank' rel="noreferrer" href='https://drive.google.com/file/d/1YlxMvBxkZ00qxW46GWs0UKy9Wu08dRgJ/view?usp=drive_link'>Resume</a></button>
</div>
</p>
</div>
</>
  );
};

export default About;